import {LOAD_MAP_TILE_LAYERS, CLEAR_MAP_TILE_LAYERS, TOGGLE_TILE_LAYER_ACTIVE, CLEAR_ACTIVE_LAYERS, CHANGE_LOADED_LAYER_OPACITY} from '../actions/mapTileLayers.js'


//TODO Change loaded to take an object describing the loaded layers state (visible, opacity)
//The order of this array will be used for sorting


function mapTileLayers(state = {available:{}, loaded:[]}, action) {
  switch (action.type) {
    case LOAD_MAP_TILE_LAYERS:
      return Object.assign({}, state, { available: action.data });

    case CLEAR_MAP_TILE_LAYERS:
      return Object.assign({}, state, { available: {} });

    case TOGGLE_TILE_LAYER_ACTIVE:
      const existingLayerIndex = state.loaded.findIndex((layer) => layer.id === action.id);
      if (existingLayerIndex >= 0) {
        return {
          ...state,
          loaded: state.loaded.filter((layer) => layer.id !== action.id),
        };
      } else {
        const layerToAdd = {
          ...state.available[action.id],
          opacity: 1,
          visible: true,
        };

        return {
          ...state,
          loaded: [...state.loaded, layerToAdd],
        };
      }

    case CLEAR_ACTIVE_LAYERS:
      return Object.assign({}, state, { loaded: [] });

    case CHANGE_LOADED_LAYER_OPACITY:
      return {
        ...state,
        loaded: state.loaded.map((layer) => (layer.id === action.id ? { ...layer, opacity: action.opacity } : layer)),
      };
      
    default:
      return state;
  }
}

export default mapTileLayers
